export const aciExchange = {
    iconName: 'exchange',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        g: {
            attr: { 'clip-path': 'url(#clip0_35044_16076)', fill: 'currentColor' },
            path: [
                {
                    attr: {
                        d: 'M14.22 13.561c0 .256-.042.486-.124.691a1.765 1.765 0 01-.348.549c-.15.153-.333.281-.55.384-.21.095-.445.164-.707.208v.746c0 .11-.011.209-.034.296a.312.312 0 01-.134.22c-.075.05-.195.076-.36.076-.149 0-.261-.029-.336-.087a.354.354 0 01-.146-.22 1.707 1.707 0 01-.022-.285v-.746a2.684 2.684 0 01-.584-.175 2.628 2.628 0 01-.505-.307 1.92 1.92 0 01-.381-.395c-.113-.169-.169-.311-.169-.428 0-.117.086-.249.258-.395a.628.628 0 01.337-.154.43.43 0 01.292.088c.09.058.172.139.247.241.127.169.273.296.437.384.165.08.348.121.55.121.24 0 .442-.03.606-.088a.8.8 0 00.37-.274.725.725 0 00.124-.428.497.497 0 00-.247-.45 2.26 2.26 0 00-.628-.274 9.104 9.104 0 01-.775-.285 4.385 4.385 0 01-.538-.23 2.124 2.124 0 01-.46-.34 1.532 1.532 0 01-.326-.472 1.596 1.596 0 01-.123-.658c0-.227.033-.432.1-.615a1.582 1.582 0 01.786-.855 2.34 2.34 0 01.629-.209v-.68c0-.11.007-.208.022-.296a.35.35 0 01.146-.209c.075-.05.19-.076.348-.076.157 0 .273.025.348.076.075.052.12.121.134.209.023.088.034.186.034.296v.67c.247.036.464.105.651.208.194.102.363.223.505.362.15.131.228.245.236.34.015.095-.041.226-.169.395a.766.766 0 01-.247.24.388.388 0 01-.269.034.894.894 0 01-.292-.143 1.397 1.397 0 00-.258-.197 1.31 1.31 0 00-.718-.197c-.12 0-.232.018-.337.054a.777.777 0 00-.258.132.771.771 0 00-.168.208.617.617 0 00-.056.263c0 .169.06.304.18.406.127.103.291.187.493.253l.651.186c.21.066.419.14.628.22.21.08.4.19.573.329.18.131.321.3.426.504.105.205.157.465.157.78z',
                    },
                },
                {
                    attr: {
                        'fill-rule': 'evenodd',
                        'clip-rule': 'evenodd',
                        d: 'M19.333 10.496a.5.5 0 01.5.5v1.333a7.834 7.834 0 01-13.53 5.376.5.5 0 11.727-.687 6.833 6.833 0 0011.803-4.689v-1.333a.5.5 0 01.5-.5z',
                    },
                },
                {
                    attr: {
                        'fill-rule': 'evenodd',
                        'clip-rule': 'evenodd',
                        d: 'M18.981 10.643a.5.5 0 01.707 0l2.667 2.666a.5.5 0 01-.707.707l-2.313-2.313-2.314 2.313a.5.5 0 11-.707-.707l2.667-2.666zM5.132 14.16a.5.5 0 01-.497-.502l.007-1.333a7.833 7.833 0 0113.557-5.308.5.5 0 11-.731.683 6.833 6.833 0 00-11.826 4.63l-.007 1.333a.5.5 0 01-.503.498z',
                    },
                },
                {
                    attr: {
                        'fill-rule': 'evenodd',
                        'clip-rule': 'evenodd',
                        d: 'M5.486 14.015a.5.5 0 01-.707-.003l-2.653-2.68a.5.5 0 01.71-.704l2.302 2.325 2.325-2.302a.5.5 0 11.703.711l-2.68 2.653z',
                    },
                },
            ],
        },
        defs: {
            clipPath: {
                attr: { id: 'clip0_35044_16076' },
                path: { attr: { fill: 'currentColor', d: 'M0 0h24v24H0z' } },
            },
        },
    },
};
